import { useLocation } from 'react-router-dom';

import Pages from '@/pages';

export const useShowEditButton = () => {
  const { pathname } = useLocation();

  const meteringPointActsPath = new RegExp(
    `/${Pages.METERING_POINT_ACTS}/[a-f0-9-]+$`,
  );

  return meteringPointActsPath.test(pathname);
};
